import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Card } from '../../layers';

var PopoverStateless =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PopoverStateless, _PureComponent);

  function PopoverStateless() {
    _classCallCheck(this, PopoverStateless);

    return _possibleConstructorReturn(this, _getPrototypeOf(PopoverStateless).apply(this, arguments));
  }

  _createClass(PopoverStateless, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["children"]);

      return React.createElement(Card, _extends({
        role: "dialog",
        elevation: 3,
        overflow: "hidden",
        minWidth: 200,
        backgroundColor: "white"
      }, props), children);
    }
  }]);

  return PopoverStateless;
}(PureComponent);

PopoverStateless.displayName = "PopoverStateless";

_defineProperty(PopoverStateless, "propTypes", _objectSpread({}, Card.propTypes, {
  /**
   * The content of the Popover.
   */
  children: PropTypes.node
}));

export { PopoverStateless as default };